import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { Values } from '../../../../../values/Values';
import Grid from '@material-ui/core/Grid';
import { Line, Pie } from 'react-chartjs-2';
import { Card, CardContent, CardHeader, colors, Hidden } from '@material-ui/core';
import moment from 'moment';
import Box from '@material-ui/core/Box';


const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    color: Values.cores.cinza
  },
  labelsGraficosRendimentoGeral: {
    color: Values.cores.preto
  },
  valorlabelsGraficosRendimentoGeral: {
    textAlign: 'right',
    color: Values.cores.preto
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function DialogDetalhesEstatisticasTrap(props) {
  const classes = useStyles();
  const {
    open,
    setOpen,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading,
    filiado,
    dados
  } = props;

  const ALTURA_CARDS = 550;
  const [labelsGraficoRendimentoPorVisitaAcertos, setLabelsGraficoRendimentoPorVisitasAcertos] = useState([]);
  const [valoresGraficoRendimentoPorVisitasAcertos, setValoresGraficoRendimentoPorVisitasAcertos] = useState([]);
  const [labelsGraficoRendimentoPorVisitaErros, setLabelsGraficoRendimentoPorVisitasErros] = useState([]);
  const [valoresGraficoRendimentoPorVisitasErros, setValoresGraficoRendimentoPorVisitasErros] = useState([]);

  useEffect(() => {
    prepararDadosRendimentoPorVisita()
  }, []);

  function prepararDadosRendimentoPorVisita() {
    for(let i = 0; i < dados.rendimentoPorVisita.length; i++){
      let descricao = moment(dados.rendimentoPorVisita[i].dataSaida).format('DD/MM/YYYY');
      labelsGraficoRendimentoPorVisitaAcertos.push(descricao);
      valoresGraficoRendimentoPorVisitasAcertos.push(dados.rendimentoPorVisita[i].percentualAcertos);

      labelsGraficoRendimentoPorVisitaErros.push(descricao);
      valoresGraficoRendimentoPorVisitasErros.push(dados.rendimentoPorVisita[i].percentualErros);
    }
    setLabelsGraficoRendimentoPorVisitasAcertos(labelsGraficoRendimentoPorVisitaAcertos);
    setValoresGraficoRendimentoPorVisitasAcertos(valoresGraficoRendimentoPorVisitasAcertos);

    setLabelsGraficoRendimentoPorVisitasErros(labelsGraficoRendimentoPorVisitaErros);
    setValoresGraficoRendimentoPorVisitasErros(valoresGraficoRendimentoPorVisitasErros);
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (

      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>

            <Typography variant="h6" className={classes.title} >TRAP AMERICANO</Typography>
            <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Grid
          container
          spacing={2}
        >
          <Hidden xsDown>
            <Grid
              item
              md={2}
            />
          </Hidden>
          <Grid
            item
            md={4}
            xs={12}
          >
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                md={12}
                xs={12}
              >
                <Box
                  boxShadow={5}
                  style={{
                    marginLeft: 10,
                    marginTop: 10,
                  }}
                >
                  <Card
                    variant={'elevation'}
                    elevation={7}
                    style={{
                      minHeight: ALTURA_CARDS,
                      maxHeight: ALTURA_CARDS
                    }}
                  >
                    <CardHeader
                    title="Rendimento geral"
                    subheader="Percentual de rendimento (ACERTOS x ERROS) do filiado em toda sua permanância no clube."
                  />
                    <Divider />
                    <CardContent>
                      <Grid
                        container
                        spacing={2}
                      >
                        <Grid
                          item
                          md={12}
                          xs={12}
                        >
                          <Pie
                            options={{
                              responsive: true
                            }}
                            data={{
                              labels: ['Acertos', 'Erros'],

                              datasets: [{
                                data: [
                                  dados.rendimentoTotal.percentualAcertos ? dados.rendimentoTotal.percentualAcertos : 0,
                                  dados.rendimentoTotal.percentualErros ? dados.rendimentoTotal.percentualErros : 100
                                ],
                                backgroundColor: [Values.cores.corPrimaria, colors.red['500']],
                                hoverBackgroundColor: [Values.cores.corPrimaria, colors.red['500']]
                              }]
                            }}/>
                        </Grid>
                        <Grid
                          item
                          md={12}
                          xs={12}
                        >
                          <Grid
                            container
                          >
                            <Grid
                              item
                              md={8}
                              xs={12}
                            >
                              <Typography variant="h6" className={classes.labelsGraficosRendimentoGeral}>Total acertos:</Typography>
                            </Grid>
                            <Grid
                              item
                              md={4}
                              xs={12}
                            >
                              <Typography variant="h6" className={classes.valorlabelsGraficosRendimentoGeral}>{dados.rendimentoTotal.quantidadeAcertos}</Typography>
                            </Grid>
                            <Grid
                              item
                              md={8}
                              xs={12}
                            >
                              <Typography variant="h6" className={classes.labelsGraficosRendimentoGeral}>Total erros:</Typography>
                            </Grid>
                            <Grid
                              item
                              md={4}
                              xs={12}
                            >
                              <Typography variant="h6" className={classes.valorlabelsGraficosRendimentoGeral}>{dados.rendimentoTotal.quantidadeErros}</Typography>
                            </Grid>
                            <Grid
                              item
                              md={8}
                              xs={12}
                            >
                              <Typography variant="h6" className={classes.labelsGraficosRendimentoGeral}>Total disparos:</Typography>
                            </Grid>
                            <Grid
                              item
                              md={4}
                              xs={12}
                            >
                              <Typography variant="h6" className={classes.valorlabelsGraficosRendimentoGeral}>{dados.rendimentoTotal.quantidadeTotalDisparos}</Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                  </CardContent>
                  </Card>
                </Box>

              </Grid>
            </Grid>

          </Grid>
          <Grid
            item
            md={4}
            xs={12}
          >
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                md={12}
                xs={12}
              >
                <Box
                  boxShadow={5}
                  style={{
                    marginLeft: 10,
                    marginTop: 10,
                  }}
                >
                  <Card
                    variant={'elevation'}
                    elevation={7}
                    style={{
                      minHeight: ALTURA_CARDS,
                      maxHeight: ALTURA_CARDS
                    }}
                  >
                    <CardHeader
                    title="Rendimento por visita"
                    subheader="Percentual de acertos e erros, por visita, do filiado em toda sua permanência no clube."
                  />
                    <Divider />
                    <CardContent>
                    <Line
                      options={{
                        scales: {
                          yAxes: [{
                            display: true,
                            ticks: {
                              min: 0,
                              max: 100
                            }
                          }]
                        }
                      }}
                      data={{
                        labels: labelsGraficoRendimentoPorVisitaAcertos,
                        datasets: [
                          {
                            label: 'Acertos',
                            fill: false,
                            lineTension: 0.3,
                            backgroundColor: 'rgba(75,192,192,0.4)',
                            borderColor: Values.cores.corPrimaria,
                            borderCapStyle: 'butt',
                            borderDash: [],
                            borderDashOffset: 0.0,
                            borderJoinStyle: 'miter',
                            pointBorderColor: Values.cores.corPrimaria,
                            pointBackgroundColor: '#fff',
                            pointBorderWidth: 1,
                            pointHoverRadius: 20,
                            pointHoverBackgroundColor: Values.cores.corPrimaria,
                            pointHoverBorderColor: 'rgba(220,220,220,1)',
                            pointHoverBorderWidth: 2,
                            pointRadius: 3,
                            pointHitRadius: 10,
                            data: valoresGraficoRendimentoPorVisitasAcertos
                          },
                          {
                            label: 'Erros',
                            fill: false,
                            lineTension: 0.3,
                            backgroundColor: 'rgba(75,192,192,0.4)',
                            borderColor: colors.red['500'],
                            borderCapStyle: 'butt',
                            borderDash: [],
                            borderDashOffset: 0.0,
                            borderJoinStyle: 'miter',
                            pointBorderColor: colors.red['500'],
                            pointBackgroundColor: '#fff',
                            pointBorderWidth: 1,
                            pointHoverRadius: 20,
                            pointHoverBackgroundColor: colors.red['500'],
                            pointHoverBorderColor: 'rgba(220,220,220,1)',
                            pointHoverBorderWidth: 2,
                            pointRadius: 3,
                            pointHitRadius: 10,
                            data: valoresGraficoRendimentoPorVisitasErros
                          }
                        ]
                      }
                    } />
                  </CardContent>
                  </Card>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Hidden xsDown>
            <Grid
              item
              md={2}
            />
          </Hidden>
        </Grid>
      </Dialog>
  );
}

export default DialogDetalhesEstatisticasTrap;
